
/**
 * @fileOverview DomCallBack module definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;
    
    define('lib/domCallback',['require','jquery','lib/Util'],function (require) {
        
        var $ = require('jquery'),
            util = require('lib/Util');

        //output console message to main ?debug=corpJS section
        $debug('DOMCallback loaded - use ?debug=DOM for messages');

        //require domReady - which fires callback upon DOM being ready to fire our module
        require(['domReady!'], function (doc) {
            /*Fires upon DOM Ready to initialize component*/
            $debug('**** Module DOMCallBack Set Up Started **** ', 'DOM'); //syntax: $debug(message, urlParam);
            
            //instantiate new object, passing the element in as a jQuery object
            new DomCallBack();
           
        });
         
       /**
         *
         * @class DomCallBack
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var DomCallBack = function () {
            this.init(); //initialize module
        };

        /**
         * Initializes the Module
         * Runs setOptions method, followed by enable/build method - chain additional ones if needed
         *
         * @method init
         * @returns {DomCallBack}
         * @private
         */
        DomCallBack.prototype.init = function () {
            this
                .fire();

            return this;
        };

        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         * Syntax for HTML should be data-options='{"exampleOption" : "bar", "enabled" : false, "xLength" : 45, "option2" : "foo"}'
         *
         * @method setOptions
         * @returns {DomCallBack}
         * @private
         */
        DomCallBack.prototype.setOptions = function () {
            //no options needed at this time
            return this;
        };

        /**
         * Sets up the module functions and fires them
         *
         * @method enable
         * @returns {DomCallBack}
         */
        DomCallBack.prototype.fire = function () {
            var self = this,
                key;
            $debug('Looping through domReady object for custom DOM Ready Events', 'DOM');
            //domReady is set in mmmSettings.js (head of page)
            for (key in domReady) {
                if (domReady.hasOwnProperty(key)) {
                    if (typeof(domReady[key]) === 'function') {
                        $debug('     Found function of: ' + key + '... [firing]','DOM');
                        domReady[key]();
                        $debug('          Fired!','DOM');
                    }
                    else {
                        $debug('     Error: Found object of "' + key  + '": which is not correctly defined as a function. It is a ' + typeof(domReady[key]) + ' \n     See https://go.3M.com/domReady for more information', 'DOM');
                    }
                }
            }

            return this;
        };

    }); //end define

}(MMMRequire));